var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAmerica(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5925_141831)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5925_141831)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H9.42857V7.46667H0V0Z",
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.42857 0V1.06667H22V0H9.42857ZM9.42857 2.13333V3.2H22V2.13333H9.42857ZM9.42857 4.26667V5.33333H22V4.26667H9.42857ZM9.42857 6.4V7.46667H22V6.4H9.42857ZM0 8.53333V9.6H22V8.53333H0ZM0 10.6667V11.7333H22V10.6667H0ZM0 12.8V13.8667H22V12.8H0ZM0 14.9333V16H22V14.9333H0Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.04785 1.07031V2.13698H2.09547V1.07031H1.04785ZM3.14309 1.07031V2.13698H4.19071V1.07031H3.14309ZM5.23833 1.07031V2.13698H6.28595V1.07031H5.23833ZM7.33357 1.07031V2.13698H8.38119V1.07031H7.33357ZM6.28595 2.13698V3.20365H7.33357V2.13698H6.28595ZM4.19071 2.13698V3.20365H5.23833V2.13698H4.19071ZM2.09547 2.13698V3.20365H3.14309V2.13698H2.09547ZM1.04785 3.20365V4.27031H2.09547V3.20365H1.04785ZM3.14309 3.20365V4.27031H4.19071V3.20365H3.14309ZM5.23833 3.20365V4.27031H6.28595V3.20365H5.23833ZM7.33357 3.20365V4.27031H8.38119V3.20365H7.33357ZM1.04785 5.33698V6.40365H2.09547V5.33698H1.04785ZM3.14309 5.33698V6.40365H4.19071V5.33698H3.14309ZM5.23833 5.33698V6.40365H6.28595V5.33698H5.23833ZM7.33357 5.33698V6.40365H8.38119V5.33698H7.33357ZM6.28595 4.27031V5.33698H7.33357V4.27031H6.28595ZM4.19071 4.27031V5.33698H5.23833V4.27031H4.19071ZM2.09547 4.27031V5.33698H3.14309V4.27031H2.09547Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5925_141831"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5925_141831"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAmerica);
export default __webpack_public_path__ + "static/media/icon-america.cf5837c36a386dbd5a47204c6c0c236c.svg";
export { ForwardRef as ReactComponent };